import { Address } from '../../../Store/components/Address';
import { Divider } from '../../../components/Divider';
import { centsToMoney } from '../../../utils/centsToMoney';

import { OrderFieldsFragment } from '../../graphql';

import { Icons } from '../Icons';
import { Row } from './Row';
import { Header } from './Header';
import { Buttons } from './Buttons';

export type CardProps = React.HTMLAttributes<HTMLDivElement> & {
	order: OrderFieldsFragment;
};

export const Card: React.FC<CardProps> = ({
	order: { id, timePlaced, items, total, store },
	className,
	...props
}) => (
	<div
		className={`px-3 border border-primary text-dark shadow order-card${
			className ? ` ${className}` : ''
		}`}
		{...props}
	>
		<Header id={id} timePlaced={timePlaced} />

		<Divider mt={0} mb={1} borderColor="primary" pullOut={3} />

		<Row align="stretch" divider>
			<div className="h-100 d-flex flex-column">
				<Icons items={items} />

				<h4 className="mb-0 pt-1 mt-auto font-weight-normal">
					${centsToMoney(total)}
				</h4>
			</div>

			<Address store={store} lineProps={{ className: 'mb-0 mt-auto' }} />
		</Row>

		<Divider mt={1} mb={0} borderColor="primary" pullOut={3} />

		<Buttons id={id} />
	</div>
);
